import { EWorldMapInitialType } from '__generated__/globalTypes';
import {
    InitialBoundsData,
    areBoundsValid,
    getBoundsOffsets
} from 'components/map/location/defaultMapLocation';
import { boundCoordinateToEdges } from 'libs/utils/world/worldUtils';
import { IPolygonV2WorldMarker } from 'react-give-me-map';

export function constructInitPositonMarker(
    bounds: InitialBoundsData,
    initialType: EWorldMapInitialType
) {
    if (!bounds || !areBoundsValid(bounds)) {
        return;
    }

    const offsets =
        initialType === EWorldMapInitialType.AUTOMATIC
            ? getBoundsOffsets(bounds)
            : { lat: 0, lng: 0 };

    const topLeft = boundCoordinateToEdges({
        lat: bounds.topLeft.lat - offsets.lat,
        lng: bounds.topLeft.lng - offsets.lng
    });
    const bottomRight = boundCoordinateToEdges({
        lat: bounds.bottomRight.lat + offsets.lat,
        lng: bounds.bottomRight.lng + offsets.lng
    });

    const marker: IPolygonV2WorldMarker = {
        id: 'bounds-rectangle',
        elementType: 'v2/polygon',
        selectable: false,
        visible: true,
        lat: (topLeft.lat + bottomRight.lat) / 2,
        lng: (topLeft.lng + bottomRight.lng) / 2,
        isExternalPoint: false,
        elementData: {
            coordinates: [
                {
                    lat: topLeft.lat,
                    lng: topLeft.lng
                },
                {
                    lat: bottomRight.lat,
                    lng: topLeft.lng
                },
                {
                    lat: bottomRight.lat,
                    lng: bottomRight.lng
                },
                {
                    lat: topLeft.lat,
                    lng: bottomRight.lng
                }
            ],
            fill: {
                isFilled: false,
                color: '#fff',
                opacity: 0,
                rawLayoutAttributes: {},
                rawPaintAttributes: {}
            },
            border: {
                hasBorder: true,
                color: '#D0021B',
                width: 3,
                opacity: 1,
                rawLayoutAttributes: {},
                rawPaintAttributes: {}
            }
        }
    };

    return marker;
}
